<script lang="ts">
	import X from '@lucide/svelte/icons/x'
	import { Dialog as DialogPrimitive, type WithoutChildrenOrChild } from 'bits-ui'
	import { type Snippet, type ComponentProps } from 'svelte'
	import { cn } from 'tailwind-variants'

	import { Button } from '#lib/components/ui/button/index.js'

	import DialogOverlay from './dialog-overlay.svelte'
	import DialogPortal from './dialog-portal.svelte'

	let {
		ref = $bindable(null),
		class: className,
		portalProps,
		children,
		showCloseButton = true,
		...restProps
	}: WithoutChildrenOrChild<DialogPrimitive.ContentProps> & {
		portalProps?: WithoutChildrenOrChild<ComponentProps<typeof DialogPortal>>
		children: Snippet
		showCloseButton?: boolean
	} = $props()
</script>

<DialogPortal {...portalProps}>
	<DialogOverlay />
	<DialogPrimitive.Content
		class={cn(
			'bg-popover text-popover-foreground ring-foreground/10 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95 fixed top-1/2 left-1/2 z-50 grid w-full max-w-[calc(100%-2rem)] -translate-x-1/2 -translate-y-1/2 gap-4 rounded-xl p-4 text-sm ring-1 duration-100 outline-none sm:max-w-md',
			className
		)}
		data-slot="dialog-content"
		bind:ref
		{...restProps}
	>
		{@render children?.()}
		{#if showCloseButton}
			<DialogPrimitive.Close data-slot="dialog-close">
				{#snippet child({ props })}
					<Button
						class="absolute top-2 right-2"
						size="icon-sm"
						variant="ghost"
						{...props}
						aria-label="Close"
					>
						<X />
					</Button>
				{/snippet}
			</DialogPrimitive.Close>
		{/if}
	</DialogPrimitive.Content>
</DialogPortal>
